/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_O3Inputs */

const en_mk_sol_ukm_o3 = /** @type {(inputs: Mk_Sol_Ukm_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing reaches a customer without a yes`)
};

const id_mk_sol_ukm_o3 = /** @type {(inputs: Mk_Sol_Ukm_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang terkirim ke pelanggan tanpa disetujui`)
};

/**
* | output |
* | --- |
* | "Nothing reaches a customer without a yes" |
*
* @param {Mk_Sol_Ukm_O3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_o3 = /** @type {((inputs?: Mk_Sol_Ukm_O3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_O3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_o3(inputs)
	return en_mk_sol_ukm_o3(inputs)
});